import React from "react";
import moment from 'moment';
import 'moment/locale/he';

const EventInfo = React.memo(props => {
    moment.locale ('he');
     return (
        <React.Fragment>
            <div className="mainEventInfoContainer">
                <div className="eventImgIinfoDiv">
                    <a href={props.items.MuseumEventImg_Url} target="_blank">
                        <img className="imgEventWebPart" src={props.items.MuseumEventImg_Url} data-holder-rendered="true"  alt={"תמונת אירוע " + props.items.Title}/>
                    </a>
                </div>
                <div className="eventDetailsContainer">
                    <h2 className="eventDetailsTitle">{props.items.Title}</h2>
                    <p className="eventSummary" dangerouslySetInnerHTML={{__html: props.items.MuseumEventInfo}}></p>
                    <ul className="eventTimeLocationDetails">
                        <li className= "listItemEvent"><span>יום {moment(props.items.MuseumEventStartDate).format('dddd')}, {moment(props.items.MuseumEventStartDate).format('DD')} ב{moment(props.items.MuseumEventEndDate).format('MMM')} {moment(props.items.MuseumEventEndDate).format('Y')}</span></li>   
                        <li className= "listItemEvent">{props.items.MuseumEventEndHour === null ? <span>בשעה {props.items.MuseumEventStartHour}</span> : <span>בין השעות {props.items.MuseumEventEndHour} - {props.items.MuseumEventStartHour}</span>}</li>   
                        <li className= "listItemEvent"><span>{props.items.MuseumEventName}</span></li>   
                        <li className= "listItemEvent"><span dangerouslySetInnerHTML={{__html: props.items.MuseumEventAddress}}></span></li>   
                        {props.items.MuseumEventNote === null ? <li className= "listItemEventHide"></li>:<li className= "listItemEvent"><span className= "notesEvent" dangerouslySetInnerHTML={{__html: props.items.MuseumEventNote}}></span></li>}   
                    </ul>
                </div>
            </div>

        </React.Fragment>
    );
});
export default EventInfo;

